import React from 'react';

import ScrollableAnchor from 'react-scrollable-anchor';
import Lightbox from 'react-images';

import FullScreen from '../components/FullScreen';
import Content from '../components/Content';
import Timeline from '../components/Timeline';
import Footer from '../components/Footer';
import Search from '../components/Search';

const FrontPageComponent = ({
  events,
  images,
  image,
  lightbox,
  isOpen,
  currentImageIndex,
} = {}) => (
  <div>
    <FullScreen>
      <div className="w-100 fl">
        <Search extraClasses="mb2 mt4 mb5-ns" />
        <div className="w-100 w-50-ns fl pa2 pa4-ns tl f5 f3-l">
          <h3 className="mt0 dn db-ns f4-m f3-l f2-ns ttu tc tl-ns">
            Møre og Romsdal
            <br /> fotograflaug 100 år
          </h3>
          <img src="/logo.png" className="a-logo" />
          <p>
            Fotograflauget (1917 - 2017) ynskjer i forbindelse med jubileet å
            vise fram hendingar, bilete og historie om laugets møter og
            medlemmar.
          </p>
          <p>
            Bruk søkefeltet i toppen av sida for å finne laugets medlemmar og
            prisar, eller klikk på bilete for å bla gjennom noko frå arkivet.
            Under finn du ein tidslinje over relaterte hendingar sida lauget
            starta opp.
          </p>
        </div>
        <div className="w-100 w-50-ns fl db pt4-ns tc pr4-ns">
          {image && (
            <img
              className="a-frontpage-image u-smooth-transitions w-100"
              src={image.src}
              alt={image.caption}
              onClick={lightbox.open}
            />
          )}
          <button
            className="button-reset a-invisible-bottom u-smooth-transitions f7 f5-l mb2"
            onClick={lightbox.open}>
            Klikk for å sjå fleir bilete frå Fotolauget
          </button>
        </div>
      </div>
      <Lightbox
        images={images}
        currentImage={currentImageIndex}
        isOpen={isOpen}
        onClickPrev={lightbox.prev}
        onClickNext={lightbox.next}
        onClickImage={e => (document.location = e.target.src)}
        onClose={lightbox.close}
        imageCountSeparator=" av "
      />
      <a href="#timeline" className="dn db-ns a-frontpage-bottom-scroll">
        <span className="di f4">Fotolauget si tidslinje</span>
        <br />
        <i className="fa fa-long-arrow-down" />
      </a>
    </FullScreen>
    <Content extraClasses="black-90 bg-white-90 pt4-l">
      <ScrollableAnchor id={'timeline'}>
        <Timeline />
      </ScrollableAnchor>
    </Content>
    <Footer>
      <span className="db di-ns">Møre og Romsdal Fotograflaug</span>
      <span className="dn di-ns"> | </span>
      <span className="db di-ns">ragnarha@gmail.com, tlf 90 84 58 61 </span>
      <span className="dn di-ns"> | </span>
      <span className="db di-ns">
        Utvikling frå{' '}
        <a className="light-blue" href="https://appucci.no">
          appucci.no
        </a>
      </span>
    </Footer>
  </div>
);

export default FrontPageComponent;



// WEBPACK FOOTER //
// ./src/pages/FrontPageComponent.js